<template>
  <div class="jin-resume-list">
    <ul class="jin-resume-list-warp">
      <li v-for="(item, i) in resumeCon" :key="item.title">
        <div class="jin-resume-list-item">
          <span class="title">{{ item.title }}</span>
          <div class="edit" @click="handleApp(item, i)">
            <Icon :name="i ? 'add' : 'edit'" />
            <span>{{ i ? '添加' : '编辑' }}</span>
          </div>
        </div>
        <component :is="item.mobileTem" :info="handleInfo(item)" :template="item.template" />
      </li>
    </ul>
    <el-button :disabled="disabled" :loading="loading" class="jin-resume-submit jin-m-button" @click="onSubmit">{{ btnName }}</el-button>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { MBaseOn, MCurr, MGrade, MAttach, MBaseUp, MResume, MAttachUp } from './index'
import { resumeApi } from '@/api'
export default {
  components: {
    MBaseOn,
    MCurr,
    MGrade,
    MAttach,
    MBaseUp,
    MResume,
    MAttachUp
  },
  data() {
    return {
      content: '',
      loading: false,
      btnName: '确认投递',
      disabled: false,
      info: []
    }
  },
  computed: {
    ...mapGetters([
      'resume',
      'drafts',
      'resumeList',
      'resumeCon',
      'submitForm'
    ]),
    id() {
      return this.$route.query.id
    },
    type() {
      return this.$route.query.type
    }
  },
  watch: {
    resumeList: {
      handler() {
        this.resetBtn()
      },
      deep: true
    }
  },
  mounted() {
    this.resetBtn()
  },
  methods: {
    ...mapActions('resume', ['GET_DRAFT']),
    ...mapMutations('resume', ['RESET_FORM']),
    handleInfo(item) {
      let info = []
      if (item.type) {
        if (item.formList && JSON.stringify(item.formList[0]) === '{}') item.formList = []
        info = item.type !== 'annex' ? item.formList : item.files
      } else {
        info = item.form
      }
      return info
    },
    resetBtn() {
      if (this.resumeList.find(item => Number(item.target_id) === Number(this.id))) {
        this.disabled = true
        this.btnName = '已投递'
      }
    },
    handleApp(item, i) {
      this.$router.push({
        path: `/list/resume/${item.template}`,
        query: {
          ...this.$route.query,
          type: this.type
        }
      })
    },
    async onSubmit() {
      await this.GET_DRAFT({ type: this.type })
      if (this.drafts) this.RESET_FORM(this.drafts)

      const curr = this.submitForm
      const type = this.type === 'upload' ? 1 : 0
      try {
        if (this.type === 'upload') {
          if (!curr.user_name || !(curr && curr.resume && curr.resume.url)) return this.Toast('请填写基本信息、上传简历')
        } else {
          if (!curr.user_name || !curr.education.length) return this.Toast('请填写基本信息、教育经历')
        }
        if (!type) {
          curr.resume = {}
        }
        const res = await resumeApi.submit({ ...curr, target_id: +this.id, type })
        this.Toast(res.message)
        await resumeApi.deleteDraft()
        // await this.GET_DRAFT({ type: this.type })
        // this.btnName = '已投递'
        // this.disabled = true
        // this.loading = false
        setTimeout(() => {
          window.location.reload()
        }, 500)
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.jin {
  &-m-container {
    // flex: 1;
    // overflow: scroll;
  }

  &-resume-list {
    // margin-top: 43px;
    padding: 0 4px 20px;

    li {
      border-bottom: 1px solid #e8e8ea;
      padding: 20px 0;
    }

    &-item {
      display: flex;
      justify-content: space-between;

      .title {
        font-size: 16px;
        font-weight: 500;
        color: #3d4351;
        line-height: 23px;
      }

      .edit {
        font-size: 13px;
        font-weight: 500;
        color: #4777f4;
        line-height: 18px;
        display: flex;
        align-items: center;

        span {
          font-size: 13px;
          margin-left: 2px;
        }
      }
    }
  }
}
</style>
